import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import AdditionalServicePanelDetail from 'src/components/AdditionalServices/AdditionalService/AdditionalServicePanel/AdditionalServicePanelDetail/AdditionalServicePanelDetail';

const mapStateToProps = (state: IStoreState) => ({
    recom: state.AdditionalServices.allServices.recom,
    checkedRecoms: state.AdditionalServices.checkedRecoms,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    specData: state.Specs.specs,
});

export default connect(mapStateToProps)(AdditionalServicePanelDetail);